export default __webpack_public_path__ + "static/media/Biohazardous_Waste.1f855197.svg";